export enum AbmIntegrationPermissionEnum {
    None = 0x00,
    CanResendConfirmToAbm = 0x01 << 0,
}
